var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldInfoCircleYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.667 12c0 4.592 3.741 8.333 8.333 8.333 4.592 0 8.333-3.741 8.333-8.333 0-4.592-3.741-8.333-8.333-8.333-4.592 0-8.333 3.741-8.333 8.333zM12 8.042a.63.63 0 0 1 .625.625v4.166a.63.63 0 0 1-.625.625.63.63 0 0 1-.625-.625V8.667A.63.63 0 0 1 12 8.042zm.592 7.883a.962.962 0 0 1-.275.175.83.83 0 0 1-.317.067.83.83 0 0 1-.317-.067.962.962 0 0 1-.275-.175.86.86 0 0 1-.175-.275.83.83 0 0 1-.066-.317.83.83 0 0 1 .066-.316c.042-.1.1-.192.175-.275a.962.962 0 0 1 .275-.175.833.833 0 0 1 .634 0c.1.041.191.1.275.175a.962.962 0 0 1 .175.275.83.83 0 0 1 .066.316.83.83 0 0 1-.066.317.86.86 0 0 1-.175.275z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldInfoCircleYellow);
export default __webpack_public_path__ + "static/media/vuesax-bold-info-circle-yellow.1ccf217dc5e087f2e4d3075d5604e011.svg";
export { ForwardRef as ReactComponent };